<template>
  <div class="main pages-training-documents-list">
    <Sidebar :current-keywords="keywords" @search="setKeywords">
      <div slot="header" class="title-bar row no-gutters px-0 py-3 d-xl-none px-lg-3">
        <div class="col-12 text-center mb-3 col-lg-4 text-lg-left mb-lg-0">
          <h1>Tech Docs</h1>
        </div>
        <div class="col-12 col-lg-8">
          <Toggles :toggles="toggles" />
        </div>
      </div>
    </Sidebar>

    <div class="title-bar row no-gutters p-3 d-none d-xl-flex">
      <div class="col-6">
        <h1>Tech Docs</h1>
      </div>
      <div class="col-6">
        <Toggles :toggles="toggles" />
      </div>
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <div v-if="!!items && items.length > 0" class="document-list row no-gutters">
            <div v-for="(item, i) in items" :key="i" class="col-12 col-md-4 col-lg-3 pb-3 px-md-2">
              <div class="document-card">
                <a
                  :href="route('training.documents.show', { document: item.id })"
                  target="_blank"
                  :style="!!item.image ? `background-image:url('${item.image.url}');` : null"
                >
                  <div class="details">
                    <h2>{{ item.title }}</h2>
                    <p>{{ item.subtitle }}</p>
                  </div>
                  <div class="overlay black-overlay"></div>
                  <div class="overlay color-overlay"></div>
                </a>
              </div>
            </div>
          </div>
          <div v-else-if="!hideNoResults" class="alert alert-info text-center">
            <p class="m-0">No results found. Try broadening your search.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center mb-3 col-lg-6 text-lg-left mb-lg-0">
          <Pagination
            class="d-inline-block"
            :total="totalPages"
            :value="parseInt(pagination.current)"
            @input="setCurrentPage"
          />
        </div>
        <div class="col-12 text-center col-lg-6 text-lg-right">
          <PageSize :value="parseInt(pagination.per_page)" :sizes="pageSizes" @input="setPerPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListingMixin from "mixins/Listing";
export default {
  mixins: [ListingMixin],
  props: {
    toggles: { type: Array, default: () => [] },
  },
  data() {
    return {
      pageSizes: [
        { value: 12, label: "12" },
        { value: 24, label: "24" },
        { value: 36, label: "36" },
        { value: 48, label: "48" },
        { value: 60, label: "60" },
      ],
    };
  },
};
</script>